import { Fragment, useCallback } from 'react';
import { ImageBackground, StatusBar, StyleSheet, View } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import PropTypes from 'prop-types';
import { UAParser } from 'ua-parser-js';

import constants from '../Config/constants';
import ImageHelper from '../Helper/Image';
import ThemeColor from '../Theme/colors';
import ThemeStyle, {
  deviceHeight,
  deviceWidth,
  globalSpacing,
} from '../Theme/styles';

import Image from './Image';

const avatarSize = 80;

function ScreenBanner({
  store_logo,
  banner,
  isProductPage = false,
  webHeight,
}) {
  const { device } = UAParser();
  const isDefaultPickupImage = ImageHelper.isPickupDefaultBanner(banner);

  useFocusEffect(
    useCallback(() => {
      StatusBar.setBarStyle('dark-content');
      if (!constants.isIOS) {
        StatusBar.setBackgroundColor('transparent');
        StatusBar.setTranslucent(true);
      }
    }, []),
  );

  return (
    <ImageBackground
      source={{ uri: banner }}
      style={[
        !isProductPage ? styles.backgroundImage : styles.backgroundImageProduct,
        isDefaultPickupImage && styles.noBannerStyle, // This is will be enabled if no banner image is available for the store
        constants.isWeb && {
          borderRadius: 20,
          height: device.type !== 'mobile' ? webHeight || 330 : 230,
        },
      ]}
      resizeMode={isDefaultPickupImage ? 'contain' : 'cover'}
      imageStyle={[
        isDefaultPickupImage && styles.noBannerImageStyle, // This is will be enabled if no banner image is available for the store
        constants.isWeb && { borderRadius: 20 },
      ]}
    >
      {Boolean(store_logo) && (
        <Fragment>
          {!constants.isWeb && <View style={styles.slantCover} />}
          <View
            style={[
              styles.imageContainer,
              ThemeStyle.shadow,
              constants.isWeb && { bottom: -(avatarSize / 2.25) },
            ]}
          >
            <Image
              source={{ uri: store_logo }}
              style={styles.image}
              resizeMode="cover"
            />
          </View>
        </Fragment>
      )}
    </ImageBackground>
  );
}

const styles = StyleSheet.create({
  backgroundImage: {
    width: '100%',
    height: 220,
    flexDirection: 'column-reverse',
  },
  backgroundImageProduct: {
    width: '100%',
    height: deviceHeight * 0.35,
    flexDirection: 'column-reverse',
  },
  slantCover: {
    position: 'absolute',
    bottom: 0,
    borderTopColor: 'transparent',
    borderRightColor: 'transparent',
    borderLeftColor: ThemeColor.white,
    borderBottomColor: ThemeColor.white,
    borderWidth: 30,
    borderLeftWidth: deviceWidth / 2,
    borderRightWidth: deviceWidth / 2,
  },
  imageContainer: {
    zIndex: 1,
    width: avatarSize,
    height: avatarSize,
    marginLeft: globalSpacing,
    borderRadius: avatarSize / 2,
    backgroundColor: ThemeColor.white,
  },
  image: {
    width: avatarSize,
    height: avatarSize,
    borderRadius: avatarSize / 2,
  },
  noBannerStyle: {
    backgroundColor: ThemeColor.green,
  },
  noBannerImageStyle: {
    height: constants.isWeb ? 150 : null,
    alignSelf: 'center',
  },
});

ScreenBanner.propsTypes = {
  banner: PropTypes.string.isRequired,
  store_logo: PropTypes.string,
  webHeight: PropTypes.number,
};

export default ScreenBanner;
